/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CustomQuestionnaireAnswerSetSource } from './CustomQuestionnaireAnswerSetSource';
import {
  CustomQuestionnaireAnswerSetSourceFromJSON,
  CustomQuestionnaireAnswerSetSourceFromJSONTyped,
  CustomQuestionnaireAnswerSetSourceToJSON,
} from './CustomQuestionnaireAnswerSetSource';

/**
 * Adds nested create feature
 * @export
 * @interface RiskProfileSources
 */
export interface RiskProfileSources {
  /**
   *
   * @type {number}
   * @memberof RiskProfileSources
   */
  readonly id: number;
  /**
   *
   * @type {Array<CustomQuestionnaireAnswerSetSource>}
   * @memberof RiskProfileSources
   */
  customQuestionnaireSources?: Array<CustomQuestionnaireAnswerSetSource>;
}

/**
 * Check if a given object implements the RiskProfileSources interface.
 */
export function instanceOfRiskProfileSources(value: object): value is RiskProfileSources {
  if (!('id' in value) || value['id'] === undefined) return false;
  return true;
}

export function RiskProfileSourcesFromJSON(json: any): RiskProfileSources {
  return RiskProfileSourcesFromJSONTyped(json, false);
}

export function RiskProfileSourcesFromJSONTyped(json: any, ignoreDiscriminator: boolean): RiskProfileSources {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    customQuestionnaireSources:
      json['custom_questionnaire_sources'] == null
        ? undefined
        : (json['custom_questionnaire_sources'] as Array<any>).map(CustomQuestionnaireAnswerSetSourceFromJSON),
  };
}

export function RiskProfileSourcesToJSON(value?: Omit<RiskProfileSources, 'id'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    custom_questionnaire_sources:
      value['customQuestionnaireSources'] == null
        ? undefined
        : (value['customQuestionnaireSources'] as Array<any>).map(CustomQuestionnaireAnswerSetSourceToJSON),
  };
}
